/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { IsProductSerializableByWarehouseResponse } from '../../models/is-product-serializable-by-warehouse-response';

export interface WarehouseControllerProductsSerializableByWarehouse$Params {
  warehouse_id: number;
  product_id?: number;
  product_purpose?: number;
  agreement_id?: number;
}

export function warehouseControllerProductsSerializableByWarehouse(http: HttpClient, rootUrl: string, params: WarehouseControllerProductsSerializableByWarehouse$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: IsProductSerializableByWarehouseResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerProductsSerializableByWarehouse.PATH, 'get');
  if (params) {
    rb.query('warehouse_id', params.warehouse_id, {});
    rb.query('product_id', params.product_id, {});
    rb.query('product_purpose', params.product_purpose, {});
    rb.query('agreement_id', params.agreement_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: IsProductSerializableByWarehouseResponse;
      }>;
    })
  );
}

warehouseControllerProductsSerializableByWarehouse.PATH = '/warehouse/products-serializable-by-warehouse';
